import HUDButton from '@/game/prefabs/GeneralUI/Buttons/HUDButton';
import UIBlocker from '@/game/prefabs/GeneralUI/UIBlocker';
import { MasteriesPanelController } from '@/game/prefabs/Masteries/MasteriesPanelController';

/* START OF COMPILED CODE */

export default class MasteriesPanel extends Phaser.GameObjects.Container {

	constructor(scene: Phaser.Scene, x?: number, y?: number) {
		super(scene, x ?? 0, y ?? 0);

		// desktopView
		const desktopView = scene.add.container(0, 0);
		desktopView.visible = false;
		this.add(desktopView);

		// uIBlocker
		const uIBlocker = new UIBlocker(scene, 0, 0);
		desktopView.add(uIBlocker);

		// mainContainer
		const mainContainer = scene.add.container(512, 384);
		desktopView.add(mainContainer);

		// bg
		const bg = scene.add.nineslice(0, 0, "Hud1", undefined, 160, 112, 8, 8, 8, 8);
		bg.scaleX = 4;
		bg.scaleY = 4;
		mainContainer.add(bg);

		// levelText
		const levelText = scene.add.bitmapText(0, -152, "Aronui", "Level 1");
		levelText.setOrigin(0.5, 0.5);
		levelText.tintTopLeft = 5387071;
		levelText.tintTopRight = 5387071;
		levelText.tintBottomLeft = 5387071;
		levelText.tintBottomRight = 5387071;
		levelText.text = "Level 1";
		levelText.fontSize = -22;
		mainContainer.add(levelText);

		// masteriesContainer
		const masteriesContainer = scene.add.container(0, 0);
		mainContainer.add(masteriesContainer);

		// header
		const header = scene.add.container(0, -216);
		mainContainer.add(header);

		// headerBacking
		const headerBacking = scene.add.nineslice(0, 0, "Hud2", undefined, 80, 18, 4, 4, 4, 8);
		headerBacking.scaleX = 4;
		headerBacking.scaleY = 4;
		header.add(headerBacking);

		// bitmaptext_3
		const bitmaptext_3 = scene.add.bitmapText(0, 0, "Aronui", "Minigame Masteries");
		bitmaptext_3.setOrigin(0.5, 0.5);
		bitmaptext_3.tintTopLeft = 985612;
		bitmaptext_3.tintTopRight = 985612;
		bitmaptext_3.tintBottomLeft = 985612;
		bitmaptext_3.tintBottomRight = 985612;
		bitmaptext_3.text = "Minigame Masteries";
		bitmaptext_3.fontSize = -24;
		header.add(bitmaptext_3);

		// closeButtonContainer
		const closeButtonContainer = scene.add.container(320, -224);
		closeButtonContainer.scaleX = 2;
		closeButtonContainer.scaleY = 2;
		mainContainer.add(closeButtonContainer);

		// closeButton
		const closeButton = new HUDButton(scene, -24, 24);
		closeButtonContainer.add(closeButton);

		// mobileView
		const mobileView = scene.add.container(0, 0);
		this.add(mobileView);

		// uIBlocker_m
		const uIBlocker_m = new UIBlocker(scene, 0, 0);
		mobileView.add(uIBlocker_m);

		// mainContainer_m
		const mainContainer_m = scene.add.container(334, 188);
		mobileView.add(mainContainer_m);

		// bg_m
		const bg_m = scene.add.nineslice(0, 0, "Hud1", undefined, 302, 156, 8, 8, 8, 8);
		bg_m.scaleX = 2;
		bg_m.scaleY = 2;
		mainContainer_m.add(bg_m);

		// levelText_m
		const levelText_m = scene.add.bitmapText(2, -96, "Aronui", "Level 1");
		levelText_m.setOrigin(0.5, 0.5);
		levelText_m.tintTopLeft = 5387071;
		levelText_m.tintTopRight = 5387071;
		levelText_m.tintBottomLeft = 5387071;
		levelText_m.tintBottomRight = 5387071;
		levelText_m.text = "Level 1";
		levelText_m.fontSize = -22;
		mainContainer_m.add(levelText_m);

		// header_m
		const header_m = scene.add.container(2, -152);
		mainContainer_m.add(header_m);

		// headerBacking_m
		const headerBacking_m = scene.add.nineslice(0, 0, "Hud2", undefined, 144, 22, 4, 4, 4, 8);
		headerBacking_m.scaleX = 2;
		headerBacking_m.scaleY = 2;
		header_m.add(headerBacking_m);

		// bitmaptext_m
		const bitmaptext_m = scene.add.bitmapText(0, 0, "Aronui", "Minigame Masteries");
		bitmaptext_m.setOrigin(0.5, 0.5);
		bitmaptext_m.tintTopLeft = 985612;
		bitmaptext_m.tintTopRight = 985612;
		bitmaptext_m.tintBottomLeft = 985612;
		bitmaptext_m.tintBottomRight = 985612;
		bitmaptext_m.text = "Minigame Masteries";
		bitmaptext_m.fontSize = -24;
		header_m.add(bitmaptext_m);

		// closeButtonContainer_m
		const closeButtonContainer_m = scene.add.container(302, -156);
		mainContainer_m.add(closeButtonContainer_m);

		// closeButton_m
		const closeButton_m = new HUDButton(scene, -24, 24);
		closeButtonContainer_m.add(closeButton_m);

		// masteriesScrollGroup_m
		const masteriesScrollGroup_m = scene.add.container(-300, -64);
		mainContainer_m.add(masteriesScrollGroup_m);

		// masteriesContainerOffset_m
		const masteriesContainerOffset_m = scene.add.container(0, 0);
		masteriesScrollGroup_m.add(masteriesContainerOffset_m);

		// masteriesContainer_m
		const masteriesContainer_m = scene.add.container(302, 104);
		masteriesContainerOffset_m.add(masteriesContainer_m);

		// scrollBarContainer_m
		const scrollBarContainer_m = scene.add.container(578, -6);
		masteriesScrollGroup_m.add(scrollBarContainer_m);

		// scrollBarBacking_m
		const scrollBarBacking_m = scene.add.nineslice(0, 0, "scrollbar-backing", undefined, 6, 104, 3, 3, 3, 3);
		scrollBarBacking_m.scaleX = 2;
		scrollBarBacking_m.scaleY = 2;
		scrollBarBacking_m.setOrigin(0.5, 0);
		scrollBarContainer_m.add(scrollBarBacking_m);

		// scrollBarHandle_m
		const scrollBarHandle_m = scene.add.image(0, 0, "scrollbar-handle");
		scrollBarHandle_m.scaleX = 2;
		scrollBarHandle_m.scaleY = 2;
		scrollBarHandle_m.setOrigin(0.5, 0);
		scrollBarContainer_m.add(scrollBarHandle_m);

		// scrollGroupBacking
		const scrollGroupBacking = scene.add.nineslice(0, -10, "1x1sprite", undefined, 576, 240, 10, 10, 10, 10);
		scrollGroupBacking.setOrigin(0, 0);
		scrollGroupBacking.alpha = 0.00001;
		masteriesScrollGroup_m.add(scrollGroupBacking);

		this.levelText = levelText;
		this.masteriesContainer = masteriesContainer;
		this.closeButton = closeButton;
		this.mainContainer = mainContainer;
		this.desktopView = desktopView;
		this.levelText_m = levelText_m;
		this.closeButton_m = closeButton_m;
		this.masteriesContainer_m = masteriesContainer_m;
		this.masteriesContainerOffset_m = masteriesContainerOffset_m;
		this.scrollBarBacking_m = scrollBarBacking_m;
		this.scrollBarHandle_m = scrollBarHandle_m;
		this.scrollGroupBacking = scrollGroupBacking;
		this.masteriesScrollGroup_m = masteriesScrollGroup_m;
		this.mainContainer_m = mainContainer_m;
		this.mobileView = mobileView;

		/* START-USER-CTR-CODE */

    this.closeButton.submitSFX = 'panel-close';
    this._controller = new MasteriesPanelController(this);
    /* END-USER-CTR-CODE */
	}

	public levelText: Phaser.GameObjects.BitmapText;
	public masteriesContainer: Phaser.GameObjects.Container;
	public closeButton: HUDButton;
	public mainContainer: Phaser.GameObjects.Container;
	public desktopView: Phaser.GameObjects.Container;
	public levelText_m: Phaser.GameObjects.BitmapText;
	public closeButton_m: HUDButton;
	public masteriesContainer_m: Phaser.GameObjects.Container;
	public masteriesContainerOffset_m: Phaser.GameObjects.Container;
	public scrollBarBacking_m: Phaser.GameObjects.NineSlice;
	public scrollBarHandle_m: Phaser.GameObjects.Image;
	public scrollGroupBacking: Phaser.GameObjects.NineSlice;
	public masteriesScrollGroup_m: Phaser.GameObjects.Container;
	public mainContainer_m: Phaser.GameObjects.Container;
	public mobileView: Phaser.GameObjects.Container;

	/* START-USER-CODE */

  _controller: MasteriesPanelController;
  get controller() {
    return this._controller;
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */
